<script>
	export default {
		name: 'ThemeExecuter',
		methods: {
			switchTheme(theme) {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				const themes_ = self_.getAppContents('themes')
				const cookie_ = self_.getCookie('theme')

				let key_ = null;
				// switch to default theme
				if(self_.isFalse(theme) && self_.isFalse(cookie_)) { 
					const default_ = self_.findObject(themes_, 'isDefault', true)
					key_ = default_.key;
				}
				// switch to theme in cookie
				else if(self_.isFalse(theme)) {
					key_ = cookie_;
				}
				// switch to target theme
				else {
					key_ = theme;
				}	

				self_.setAppState('theme', key_)
				self_.setCookie('theme', key_)

				// set dark theme for vuetify
				const dark_ = themes_[key_].isDarkTheme;
				if(self_.isFalse(dark_)) {
					vuetify_.theme.isDark = false;
				} else {
					vuetify_.theme.isDark = true;
				}
			}
		}
	}
</script>	